
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/645W-LED-1000W-HPS-Grow-Series-Platinum-OG",
      function () {
        return require("private-next-pages/645W-LED-1000W-HPS-Grow-Series-Platinum-OG.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/645W-LED-1000W-HPS-Grow-Series-Platinum-OG"])
      });
    }
  